import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { NoOrganisationPage } from '@/pages/public/no-organisation-page';
import { useSession } from './use-session';

/**
 * Step 17e: an organisation's app is for its own people. Tekansa staff (Super Admin, Support)
 * work in the Super Admin panel and enter an organisation only through "Log in as" (or a
 * read-only "View as"), so the two never mix.
 */
export function RequireOrgApp({ children }: { children: ReactNode }) {
  const session = useSession();
  if (session.platformRole !== null && !session.actAs) return <Navigate to="/admin" replace />;
  // Module 2: removed from the organisation they used: one clear page, not an empty app.
  if (!session.tenant) return <NoOrganisationPage />;
  return children;
}

/**
 * Module 2: the Super Admin panel is for Tekansa staff only. Anyone else (an organisation's
 * admin or member, or staff while inside an organisation through "Log in as") goes to their
 * organisation's Home, never into the panel's frame.
 */
export function RequireStaff({ children }: { children: ReactNode }) {
  const session = useSession();
  if (session.platformRole === null || session.actAs) return <Navigate to="/home" replace />;
  return children;
}
